import React from 'react';

import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import Item from '@r1-frontend/ui-react/organisms/OrderSummary/Item';
import { OrderLines } from '@r1-frontend/ui-react/organisms/OrderSummary/OrderLines';
import { TItemTypes } from '@r1-frontend/ui-react/organisms/OrderSummary/types';

import * as S from './styled';

export type TOrderSummary = {
    title?: string,
    items: TItemTypes[],
    gapSize?: 'small' | 'large',
};

const OrderSummary = (
    {
        title,
        items,
        gapSize = 'large',
        ...props
    }: TOrderSummary,
): JSX.Element => {
    return (
        <S.Wrapper {...props} $gapSize={gapSize}>
            {title ? <H3 as='h2' $withIndent={false}>{title}</H3> : null}

            {items.map((itemList, idx) => {
                if (itemList === 'separator') {
                    return <S.Separator key={`separator_${idx}`}/>;
                }

                if ((typeof itemList === 'object' || typeof itemList === 'function') && (itemList !== null) && 'total' in itemList) {
                    const { title: totalTitle = 'Итого:', ...item } = itemList.total;
                    return <Item key={`single_item_${totalTitle}`} title={totalTitle} {...item} />;
                }

                if (Array.isArray(itemList) && itemList.length > 0) {
                    return <OrderLines items={itemList} key={`order_lines_${idx}`}/>;
                }

                return null;
            })}
        </S.Wrapper>
    );
};

export default OrderSummary;
